<div
  *ngIf="viewState === 'form'"
  class="w-full lg:max-w-full lg:flex login-page"
>
  <div
    class="bg-cover bg-center bg-no-repeat lg:border-l-0 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r pt-6 w-full card-form"
    style="
      background-image: url(&quot;assets/img/jpo2025.png&quot;);
      background-size: cover;
      background-position: center;
      background-attachment: fixed;
    "
  >
    <div class="w-4/5 grid-cols-1 flex place-content-center">
      <app-card-form style="opacity: 0.7">
        <div id="page-one">
          <div class="flex justify-between mb-10">
            <div
              class="logo-icon"
              style="
                background-image: url(&quot;assets/img/logo_unchk.png&quot;);
              "
            ></div>
            <div
              class="logo-icon"
              style="
                background-image: url(&quot;assets/img/logo_master_card.png&quot;);
              "
            ></div>
          </div>
          <div class="flex justify-center items-center">
            <div class="text-center">
              <span class="font-bold text-2xl">
                FORMULAIRE DE VALIDATION DE PARTICIPATION À L'ACTIVITE :
                {{ data?.activityName }}
              </span>
              <br />
              Programme Force-N
            </div>
          </div>
        </div>

        <div class="mt-6 sm:mx-auto sm:w-full lg:w-full">
          <form [formGroup]="confirmationForm" class="space-y-6">
            <div>
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div class="flex justify-between gap-2 gap-6 my-6">
                <span class="font-bold text-2xl">
                  I. INFORMATIONS PERSONNELLES</span
                >
              </div>
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div class="grid md:grid-cols-3 md:gap-6 my-6">
                <div class="col-span-3 md:col-span-1 hidden md:block">
                  <div class="flex items-center gap-1">
                    <span>Prénom - Nom</span>
                    <span class="text-red-500">*</span>
                  </div>
                </div>

                <div class="col-span-3 md:col-span-1">
                  <label for="prenom" class="block mb-5 font-medium md:hidden">
                    Prénom <span class="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="prenom"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-gray-300"
                    formControlName="prenom"
                  />
                  <p class="mt-3 hidden md:block">Prénom</p>
                </div>

                <div class="col-span-3 md:col-span-1">
                  <label
                    for="nom"
                    class="block mb-5 mt-8 font-medium md:hidden"
                  >
                    Nom <span class="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="nom"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-gray-300 bg-white"
                    formControlName="nom"
                  />
                  <p class="mt-3 hidden md:block">Nom</p>
                </div>
              </div>

              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Adresse email &nbsp;
                      <p style="color: #ff0000">*</p>
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <input
                      type="email"
                      id="email"
                      class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                      formControlName="email"
                      placeholder="Par ex : monnom@exemple.com"
                    />
                  </div>
                </div>
              </div>

              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Numéro Wave &nbsp;
                      <p style="color: #ff0000">*</p>
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <input
                      type="tel"
                      id="waveNumber"
                      inputmode="numeric"
                      maxlength="9"
                      class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                      formControlName="waveNumber"
                      (keypress)="onlyNumber($event)"
                      [style.border]="
                        isFieldInvalid('waveNumber') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <p
                      *ngIf="isFieldInvalid('waveNumber')"
                      class="mt-2 text-sm"
                      style="color: #eb1c1c"
                    >
                      Veuillez saisir un numéro Wave valide (9 chiffres).
                    </p>
                  </div>
                </div>
              </div>

              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Code validation &nbsp;
                      <p style="color: #ff0000">*</p>
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="flex space-x-10">
                    <input
                      type="text"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      maxlength="1"
                      formControlName="pin1"
                      class="w-12 h-12 text-center text-lg rounded-md border-0 py-1.5 ring-1 ring-inset ring-gray-300"
                      (keypress)="onlyNumber($event)"
                      (input)="autoFocus($event, 'pin2')"
                      [style.border]="
                        isFieldInvalid('pin1') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <input
                      type="text"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      maxlength="1"
                      formControlName="pin2"
                      class="w-12 h-12 text-center text-lg rounded-md border-0 py-1.5 ring-1 ring-inset ring-gray-300"
                      (keypress)="onlyNumber($event)"
                      (input)="autoFocus($event, 'pin3')"
                      [style.border]="
                        isFieldInvalid('pin2') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <input
                      type="text"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      maxlength="1"
                      formControlName="pin3"
                      class="w-12 h-12 text-center text-lg rounded-md border-0 py-1.5 ring-1 ring-inset ring-gray-300"
                      (keypress)="onlyNumber($event)"
                      (input)="autoFocus($event, 'pin4')"
                      [style.border]="
                        isFieldInvalid('pin3') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <input
                      type="text"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      maxlength="1"
                      formControlName="pin4"
                      class="w-12 h-12 text-center text-lg rounded-md border-0 py-1.5 ring-1 ring-inset ring-gray-300"
                      (keypress)="onlyNumber($event)"
                      [style.border]="
                        isFieldInvalid('pin4') ? '2px solid #eb1c1c' : ''
                      "
                    />
                  </div>
                </div>
              </div>

              <hr class="h-1 my-8 bg-green-500 border-0 dark:bg-gray-700" />

              <div
                class="flex justify-center items-center"
                *ngIf="filled"
                style="color: #eb1c1c"
              >
                Veuillez renseigner tous les champs requis!
              </div>
              <div
                class="flex justify-center items-center"
                *ngIf="!codeMatched"
                style="color: #eb1c1c"
              >
                Code incorrect. Vérifiez le code de présence auprès de
                l'organisateur.
              </div>

              <div>
                <app-spinner *ngIf="showSpinner"></app-spinner>
              </div>

              <div class="flex justify-end items-center">
                <button
                  type="submit"
                  class="rounded-md w-48 h-12 px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 btn-login"
                  [disabled]="confirmationForm.invalid || isSubmitting"
                  (click)="onSubmitForm()"
                >
                  Confirmer
                </button>
              </div>

              <div class="flex justify-center mt-8">
                <div
                  class="logo-icon"
                  style="
                    background-image: url(&quot;assets/img/logo_force_n.png&quot;);
                  "
                ></div>
              </div>
            </div>
          </form>
        </div>
      </app-card-form>
    </div>
  </div>
</div>

<!-- Déjà présent -->
<div
  *ngIf="viewState === 'already-present'"
  class="h-screen w-screen bg-cover bg-center"
  style="background-image: url(&quot;assets/img/jpo2025_mobile.png&quot;)"
>
  <div
    class="flex h-full w-full items-center justify-center bg-slate-900/70 backdrop-blur-md px-4"
  >
    <div
      class="w-full max-w-sm rounded-2xl bg-white p-7 shadow-2xl dark:bg-gray-800"
      role="status"
    >
      <div class="flex items-center gap-2">
        <svg
          class="h-5 w-5 text-blue-600 dark:text-blue-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="2.5"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M4.5 12.75l6 6 9-13.5"
          />
        </svg>
        <span
          class="text-xs font-semibold uppercase tracking-wider text-blue-600 dark:text-blue-400"
        >
          Déjà enregistré
        </span>
      </div>

      <h3
        class="mt-3 text-xl font-semibold leading-snug text-gray-900 dark:text-white"
      >
        {{ data?.activityName | titlecase }}
      </h3>

      <p class="mt-2 text-sm leading-relaxed text-gray-500 dark:text-gray-400">
        <strong
          >{{ data?.beneficiaryFirstName | titlecase }}
          {{ data?.beneficiaryLastName | titlecase }}</strong
        >
        a déjà été enregistré(e) comme présent(e) à cette activité. Aucune
        action supplémentaire n'est nécessaire.
      </p>
    </div>
  </div>
</div>

<!-- Pas encore confirmé -->
<div
  *ngIf="viewState === 'not-confirmed'"
  class="h-screen w-screen bg-cover bg-center"
  style="background-image: url(&quot;assets/img/jpo2025_mobile.png&quot;)"
>
  <div
    class="flex h-full w-full items-center justify-center bg-slate-900/70 backdrop-blur-md px-4"
  >
    <div
      class="w-full max-w-sm rounded-2xl bg-white p-7 shadow-2xl dark:bg-gray-800"
      role="status"
    >
      <div class="flex items-center gap-2">
        <svg
          class="h-5 w-5 text-amber-500 dark:text-amber-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="2.5"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 9v3.75m0 3.75h.008v.008H12v-.008ZM21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
        <span
          class="text-xs font-semibold uppercase tracking-wider text-amber-500 dark:text-amber-400"
        >
          Participation non confirmée
        </span>
      </div>

      <h3
        class="mt-3 text-xl font-semibold leading-snug text-gray-900 dark:text-white"
      >
        {{ data?.activityName | titlecase }}
      </h3>

      <p class="mt-2 text-sm leading-relaxed text-gray-500 dark:text-gray-400">
        <strong
          >{{ data?.beneficiaryFirstName }}
          {{ data?.beneficiaryLastName }}</strong
        >
        n'a pas confirmé sa participation à cette activité.
      </p>

      <p class="mt-2 text-sm leading-relaxed text-gray-500 dark:text-gray-400">
        Si la personne peut encore être accueillie, vous pouvez valider
        directement sa présence.
      </p>

      <button
        type="button"
        (click)="openFormFromNotConfirmed()"
        class="mt-6 w-full rounded-xl bg-emerald-600 px-4 py-3 text-center transition hover:bg-emerald-700 focus:outline-none focus:ring-4 focus:ring-emerald-300"
      >
        <span
          class="inline-flex items-center justify-center gap-2 text-sm font-semibold text-white"
        >
          <svg
            width="18"
            height="18"
            class="shrink-0"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
            <path d="M6 21v-2a4 4 0 0 1 4 -4h4" />
            <path d="M15 19l2 2l4 -4" />
          </svg>
          <span>Valider sa présence</span>
        </span>
      </button>

      <p class="mt-4 text-center text-xs text-gray-400 dark:text-gray-500">
        Sinon, informez la personne que sa participation n'avait pas été
        confirmée.
      </p>
    </div>
  </div>
</div>

<!-- Succès -->
<div
  *ngIf="viewState === 'confirmed'"
  class="h-screen w-screen bg-cover bg-center"
  style="background-image: url(&quot;assets/img/jpo2025_mobile.png&quot;)"
>
  <div
    class="flex h-full w-full items-center justify-center bg-slate-900/70 backdrop-blur-md px-4"
  >
    <div
      class="w-full max-w-sm rounded-2xl bg-white p-7 shadow-2xl dark:bg-gray-800"
      role="status"
    >
      <div class="flex items-center gap-2">
        <svg
          class="h-5 w-5 text-emerald-600 dark:text-emerald-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="2.5"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M4.5 12.75l6 6 9-13.5"
          />
        </svg>
        <span
          class="text-xs font-semibold uppercase tracking-wider text-emerald-600 dark:text-emerald-400"
        >
          Présence enregistrée
        </span>
      </div>

      <h3
        class="mt-3 text-xl font-semibold leading-snug text-gray-900 dark:text-white"
      >
        {{ data?.activityName | titlecase }}
      </h3>

      <p class="mt-2 text-sm leading-relaxed text-gray-500 dark:text-gray-400">
        La présence de
        <strong
          >{{ data?.beneficiaryFirstName | titlecase }}
          {{ data?.beneficiaryLastName | titlecase }}</strong
        >
        a bien été enregistrée pour cette activité.
      </p>
    </div>
  </div>
</div>

<!-- Erreur -->
<div
  *ngIf="viewState === 'error'"
  class="h-screen w-screen bg-cover bg-center"
  style="background-image: url(&quot;assets/img/jpo2025_mobile.png&quot;)"
>
  <div
    class="flex h-full w-full items-center justify-center bg-slate-900/70 backdrop-blur-md px-4"
  >
    <div
      class="w-full max-w-sm rounded-2xl bg-white p-7 shadow-2xl dark:bg-gray-800"
      role="status"
    >
      <div class="flex items-center gap-2">
        <svg
          class="h-5 w-5 text-red-500 dark:text-red-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="2.5"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 9v3.75m0 3.75h.008v.008H12v-.008ZM21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
        <span
          class="text-xs font-semibold uppercase tracking-wider text-red-500 dark:text-red-400"
        >
          Une erreur est survenue
        </span>
      </div>

      <p class="mt-3 text-sm leading-relaxed text-gray-500 dark:text-gray-400">
        Le traitement de ce scan a échoué. Réessayez, ou vérifiez le lien/QR
        code utilisé.
      </p>
    </div>
  </div>
</div>
<!-- Code expiré -->
<div
  *ngIf="viewState === 'code-expired'"
  class="h-screen w-screen bg-cover bg-center"
  style="background-image: url(&quot;assets/img/jpo2025_mobile.png&quot;)"
>
  <div
    class="flex h-full w-full items-center justify-center bg-slate-900/70 backdrop-blur-md px-4"
  >
    <div
      class="w-full max-w-sm rounded-2xl bg-white p-7 shadow-2xl dark:bg-gray-800"
      role="status"
    >
      <div class="flex items-center gap-2">
        <svg
          class="h-5 w-5 text-slate-500 dark:text-slate-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="2.5"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
          />
        </svg>
        <span
          class="text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400"
        >
          Validation indisponible
        </span>
      </div>

      <h3
        class="mt-3 text-xl font-semibold leading-snug text-gray-900 dark:text-white"
      >
        {{ data?.activityName | titlecase }}
      </h3>

      <p class="mt-2 text-sm leading-relaxed text-gray-500 dark:text-gray-400">
        Il n'y a pas de code de présence valable pour cette activité : elle est
        terminée, ou aucun code n'a encore été généré.
      </p>

      <p class="mt-6 text-xs text-gray-400 dark:text-gray-500">
        Contactez l'organisateur de l'activité.
      </p>
    </div>
  </div>
</div>
